import { render, staticRenderFns } from "./IncomeExpenditureAccount.vue?vue&type=template&id=62c6d031&scoped=true"
import script from "./IncomeExpenditureAccount.vue?vue&type=script&lang=js"
export * from "./IncomeExpenditureAccount.vue?vue&type=script&lang=js"
import style0 from "./IncomeExpenditureAccount.vue?vue&type=style&index=0&id=62c6d031&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c6d031",
  null
  
)

export default component.exports